'use strict';

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/icon/style/index.js
// module id = 680
// module chunks = 0